import React from 'react'
import DataProvider from './contexts/data-context'
import { withRouter } from 'react-router-dom'

const DataLayer = ({ children, location: { pathname, search } }) => {
  const isRestricted = () => {
    return !/^\/(auth|public)(?=\/|$)/i.test(pathname)
  }

  const CustomLayer = () => {
    if (!isRestricted()) {
      return children
    }
    const queryParameters = new URLSearchParams(search)
    return <DataProvider product={queryParameters.get('product')}>{children}</DataProvider>
  }

  return CustomLayer()
}

export default withRouter(DataLayer)
